module.exports = __webpack_public_path__ + "static/media/nurse.267710a6.png";